import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '~/tools/makeStyles';
import { List, ListItem, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '20px',
    fontWeight: 500,
    padding: '0 10px',
    textAlign: 'center',
    marginBottom: 20,
  },
  listItem: {
    margin: 0,
    padding: 0,
    borderTop: '1px solid #efefef',
  },
  link: {
    width: '100%',
    minHeight: 19,
    lineHeight: '19px',
    padding: '10px',
    margin: 0,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: '#efefef',
      textDecoration: 'none',
    },
  },
  surveyName: {
    fontSize: '18px',
    fontWeight: 500,
    marginTop: '4px',
  },
  surveyList: {
    padding: 0,
  },
  langBadgeContainer: {},
  langBadge: {
    backgroundColor: '#4f4f4f',
    color: 'white',
    fontSize: '10px',
    padding: '3px 5px 1px 5px',
    textTransform: 'uppercase',
  },
}));

const KioskList = ({ linkToSurvey, surveyList = [], onClickSurvey }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('docTitle.kioskList');
    return () => {
      // Temp use a clean up function here before declare specific titles for each page
      document.title = 'WorkTango Pulse';
    };
  }, [t]);

  return (
    <>
      <Typography variant="h1" className={styles.title}>
        {t('kiosk.selectSurvey')}
      </Typography>
      <List className={styles.surveyList}>
        {surveyList.map((survey, i) => {
          return (
            <ListItem className={styles.listItem} key={i}>
              <Link
                onClick={() => onClickSurvey(survey)}
                className={styles.link}
                color="inherit"
                component={RouterLink}
                to={linkToSurvey(survey.surveyCode)}
                underline="hover"
              >
                <div className={styles.langBadgeContainer}>
                  <span className={styles.langBadge}>{t(survey.langISOCode)}</span>
                </div>
                <Typography variant="h2" className={styles.surveyName}>
                  {survey.name}
                </Typography>
              </Link>
            </ListItem>
          );
        })}
      </List>
    </>
  );
};

KioskList.propTypes = {
  linkToSurvey: PropTypes.func,
  surveyList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      hashCode: PropTypes.string,
    }),
  ),
  onClickSurvey: PropTypes.func.isRequired,
};

export default KioskList;
